import _find from 'lodash/find';
import formatDestination from '../transforms/formatDestination';

export default function getDestinationByDestinationCode(destinationCode) {
  return (dispatch, getState) => {
    const destinations = getState().templates.destinations.destinations;
    const { destinationToCountryMap } = getState().selectDestinations;
    const countryCode = destinationToCountryMap[destinationCode];

    if (countryCode === undefined) {
      return {};
    }

    const country = _find(destinations, (country) => country.code === countryCode);
    const destination = _find(country.destinations, (destination) => destination.code === destinationCode);
    const formattedDestination = formatDestination(destination, country);

    return formattedDestination;
  };
}
